import { useState, useEffect, useCallback, useRef } from 'react';

// ref 대신 threshold만 인자로 받습니다.
const useViewportCheck = (threshold = 768) => {
  // window.innerWidth를 기준으로 상태를 초기화합니다.
  const [isBelowThreshold, setIsBelowThreshold] = useState(window.innerWidth <= threshold);
  const timerRef = useRef(null);

  // 너비를 체크하는 로직을 window.innerWidth를 사용하도록 변경합니다.
  const checkWidth = useCallback(() => {
    const isNarrow = window.innerWidth <= threshold;
    setIsBelowThreshold(isNarrow);
  }, [threshold]);

  // 성능을 위한 디바운스 로직은 그대로 유지합니다.
  const debouncedCheckWidth = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(checkWidth, 100);
  }, [checkWidth]);

  useEffect(() => {
    // 이제 ResizeObserver는 필요 없으므로 window의 resize 이벤트만 감지합니다.
    window.addEventListener('resize', debouncedCheckWidth);

    // 컴포넌트가 언마운트될 때 이벤트 리스너를 정리합니다.
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      window.removeEventListener('resize', debouncedCheckWidth);
    };
  }, [debouncedCheckWidth]); // 의존성 배열도 간단해집니다.

  return isBelowThreshold;
};

export default useViewportCheck;
